import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Box, Drawer } from '@mui/material';
import NavSection from './NavSection';
import sidebarConfig from './SidebarConfig';

const DRAWER_WIDTH = 280;

export default function Sidebar({ isOpenSidebar, onCloseSidebar }) {
  const { pathname } = useLocation();

  useEffect(() => {
    if (isOpenSidebar) {
      onCloseSidebar();
    }
  }, [pathname]);

  return (
    <Drawer
      open={isOpenSidebar}
      onClose={onCloseSidebar}
      PaperProps={{
        sx: { width: DRAWER_WIDTH }
      }}
      sx={{
        zIndex: 1400
      }}
    >
      <Box sx={{ px: 2.5, py: 3 }}>
        <Box component='img' src='/avidlogo.svg'
          sx={{
            display: 'flex',
            alignItems: 'flex-start',
            height: 40
          }}
        />
      </Box>
      <NavSection navConfig={sidebarConfig} />
    </Drawer>
  )
}
